import { Navigate } from "react-router";
import type { ElementType } from "react";
import FuseLoading from "@fuse/core/FuseLoading";
import { useVerificaMenuRouteGuard } from "./hooks/usePermissoes";
import useUser from "@auth/user/useUser";

type RotaProtegida = {
	readonly tag?: string;
};

type PermissaoRotaGuardProps = {
	readonly route: RotaProtegida;
	readonly component: ElementType;
};

/**
 * Protege o acesso direto a uma rota verificando a permissão no servidor (`verificaPermissao`)
 * ao entrar na tela. Usuário Space tem bypass; sem permissão redireciona para /401.
 * Enquanto a `tag` estiver vazia, o guard não chama o backend (no-op de permissão).
 */
export default function PermissaoRotaGuard(props: PermissaoRotaGuardProps) {
	const { route, component: Component } = props;

	const { data: user } = useUser();
	const isSpaceUser = Boolean(user?.eh_usuario_space);
	const tag = route.tag ?? "";

	const { isLoading, isError } = useVerificaMenuRouteGuard(tag, !isSpaceUser && Boolean(tag));

	if (isSpaceUser) return <Component />;
	if (tag && isLoading) return <FuseLoading />;
	if (tag && isError) return <Navigate to="/401" replace />;

	return <Component />;
}
